var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":"回到旧版导航","placement":"right"}},[_c('div',{staticClass:"enjoy-page-tag-box",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"content"},[_vm._v("旧版")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }